import { useState } from 'react';
import '@/App.css';
import { ThemeProvider } from '@/components/ThemeProvider';
import { Toaster } from '@/components/ui/sonner';
import { ScenarioSelector } from '@/components/ScenarioSelector';
import { GameScreen } from '@/components/GameScreen';

function App() {
  const [currentScenario, setCurrentScenario] = useState(null);
  
  const handleSelectScenario = (scenario) => {
    setCurrentScenario(scenario);
  };
  
  const handleExitScenario = () => {
    setCurrentScenario(null);
  };
  
  return (
    <ThemeProvider defaultTheme="dark" storageKey="crisis-command-theme">
      <div className="App">
        {!currentScenario ? (
          <ScenarioSelector onSelectScenario={handleSelectScenario} />
        ) : (
          <GameScreen scenario={currentScenario} onExit={handleExitScenario} />
        )}
        <Toaster />
      </div>
    </ThemeProvider>
  );
}

export default App;